import { useId } from 'react';

import { FieldLabel } from '@/shared/ui/FieldLabel';

/**
 * Caixa de marcar com rotulo e ajuda (i), para as opcoes de sim ou nao do cadastro
 * de usuarios e perfis.
 */
export function Caixa({
  label,
  checked,
  onChange,
  disabled = false,
  hint,
}: {
  label: string;
  checked: boolean;
  onChange: (marcado: boolean) => void;
  disabled?: boolean;
  hint?: string;
}) {
  const id = useId();
  return (
    <div className="flex flex-col gap-0.5">
      <div className="flex items-center gap-2">
        <input
          id={id}
          type="checkbox"
          className="size-4 accent-[var(--color-brand-500)]"
          checked={checked}
          disabled={disabled}
          onChange={(evento) => onChange(evento.target.checked)}
        />
        <FieldLabel htmlFor={id} label={label} className="text-sm text-ink-800" />
      </div>
      {hint ? <p className="pl-6 text-2xs text-ink-500">{hint}</p> : null}
    </div>
  );
}
